<template>
  <div class="plano-trabalho">
    <div class="d-flex justify-space-between align-center mb-4 flex-wrap">
      <div>
        <h3 class="mb-1">Plano de Trabalho</h3>
        <p class="subtitle mb-0">
          Defina o período previsto para execução de cada produto habilitado no município.
        </p>
      </div>
      <div class="d-flex align-center actions">
        <v-btn color="primary" class="mr-3" :loading="saving" @click="salvar">
          Salvar Plano
        </v-btn>
        <v-btn
          color="primary"
          outlined
          :loading="downloading"
          @click="baixarPdf"
        >
          Baixar PDF
        </v-btn>
      </div>
    </div>

    <v-alert type="info" dense class="mb-4">
      Utilize o formato MM/AA para registrar o mês e o ano previstos. Os campos vazios não serão salvos.
    </v-alert>

    <v-alert v-if="grupos.length === 0" type="info" dense>
      Nenhum produto habilitado foi encontrado para este município.
    </v-alert>

    <v-card
      v-for="grupo in grupos"
      :key="grupo.municipioGrupoSolucaoId"
      class="mb-4"
      outlined
    >
      <v-card-title class="grupo-titulo">
        {{ grupo.nome }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-simple-table dense>
          <thead>
            <tr>
              <th class="text-left">Produto</th>
              <th class="text-center coluna-data">Início (MM/AA)</th>
              <th class="text-center coluna-data">Fim (MM/AA)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="solucao in grupo.solucoes" :key="solucao.municipioSolucaoId">
              <td class="produto">{{ solucao.nome }}</td>
              <td class="text-center coluna-input">
                <v-text-field
                  v-model="solucao.inicio"
                  dense
                  hide-details
                  outlined
                  class="campo-data"
                  placeholder="07/25"
                  v-mask="'##/##'"
                  :error="dataInvalidaNoCampo(solucao.inicio)"
                ></v-text-field>
              </td>
              <td class="text-center coluna-input">
                <v-text-field
                  v-model="solucao.fim"
                  dense
                  hide-details
                  outlined
                  class="campo-data"
                  placeholder="07/25"
                  v-mask="'##/##'"
                  :error="dataInvalidaNoCampo(solucao.fim)"
                ></v-text-field>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { planoTrabalhoApi } from "@/apis";
import { mapActions } from "vuex";

export default {
  name: "PlanoTrabalho",
  data() {
    return {
      grupos: [],
      saving: false,
      downloading: false,
    };
  },
  computed: {
    municipioId() {
      return this.$route.params.id;
    },
  },
  mounted() {
    this.carregar();
  },
  methods: {
    ...mapActions(["setLoading"]),
    carregar() {
      this.setLoading(true);
      planoTrabalhoApi
        .list(this.municipioId)
        .then((resp) => {
          this.grupos = resp.data || [];
        })
        .catch(() =>
          this.$notification.error("Erro ao carregar o Plano de Trabalho.")
        )
        .finally(() => this.setLoading(false));
    },
    validarData(valor) {
      if (!valor) return true;
      return /^((0[1-9])|(1[0-2]))\/\d{2}$/.test(valor);
    },
    dataInvalidaNoCampo(valor) {
      if (!valor || valor.length < 5) return false;
      return !this.validarData(valor);
    },
    montarPayload() {
      const planos = [];
      this.grupos.forEach((grupo) => {
        (grupo.solucoes || []).forEach((solucao) => {
          planos.push({
            municipioSolucaoId: solucao.municipioSolucaoId,
            inicio: solucao.inicio?.trim() || null,
            fim: solucao.fim?.trim() || null,
          });
        });
      });

      return { municipioId: parseInt(this.municipioId), planos };
    },
    salvar() {
      const payload = this.montarPayload();
      const datasInvalidas = payload.planos.some(
        (plano) => !this.validarData(plano.inicio) || !this.validarData(plano.fim)
      );

      if (datasInvalidas) {
        this.$notification.error("Use o formato MM/AA para preencher início e fim.");
        return;
      }

      this.saving = true;
      planoTrabalhoApi
        .save(payload)
        .then(() => this.$notification.success("Plano de Trabalho salvo com sucesso!"))
        .catch(() => this.$notification.error("Erro ao salvar o Plano de Trabalho."))
        .finally(() => (this.saving = false));
    },
    baixarPdf() {
      this.downloading = true;
      planoTrabalhoApi
        .download(this.municipioId)
        .then((response) => {
          const fileName =
            response.headers["filename"] ||
            response.headers["fileName"] ||
            `Plano de Trabalho - ${this.municipioId}.pdf`;

          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
        })
        .catch(() =>
          this.$notification.error(
            "Erro ao baixar o PDF do Plano de Trabalho."
          )
        )
        .finally(() => {
          this.downloading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.plano-trabalho {
  .subtitle {
    color: #555;
    font-size: 14px;
  }

  .grupo-titulo {
    font-weight: 600;
    font-size: 16px;
    color: #26408c;
  }

  .produto {
    max-width: 420px;
    white-space: normal;
  }

  .campo-data {
    max-width: 120px;
  }

  .coluna-data,
  .coluna-input {
    width: 180px;
  }

  .actions {
    gap: 10px;
  }
}
</style>
